import { FieldConfig } from 'model/deals.model';
import { useEffect, useState } from 'react';
import { DealsService } from 'service/deals.service';
import { BaseDealForm } from '../BaseDealForm';

const BASE_FIELDS: FieldConfig[] = [
  {
    name: 'dealDetails.stageName',
    label: 'Stage',
    type: 'select',
    required: true,
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.eventType',
    label: 'Event type',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  { name: 'dealDetails.eventName', label: 'Event name', type: 'text', xs: 12, sm: 6 },
  { name: 'dealDetails.eventDate', label: 'Event date', type: 'date', xs: 12, sm: 12 },
  { name: 'dealDetails.eventLocation', label: 'Event location', type: 'text', xs: 12, sm: 12 },
  { name: 'dealDetails.duration', label: 'Duration (hours)', type: 'number', xs: 12, sm: 6 },
  {
    name: 'dealDetails.travelRequired',
    label: 'Travel required',
    type: 'checkbox',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.contentRights',
    label: 'Content rights',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.paymentTerms',
    label: 'Payment terms',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.careerState',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
];

export const EventAppearance = () => {
  const [fields, setFields] = useState<FieldConfig[]>(BASE_FIELDS);

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const dealTypeKey = 'EVENT_APPEARANCE';
        const dropdownsData = await DealsService.getDealDropdowns(dealTypeKey);

        const updatedFields = BASE_FIELDS.map((field) => {
          if (field.type === 'select' && field.options) {
            let options: string[] = [];

            switch (field.name) {
              case 'dealDetails.stageName':
                if (dropdownsData.stages && Array.isArray(dropdownsData.stages)) {
                  options = dropdownsData.stages.map((stage: any) => stage.stageName || stage);
                }
                break;
              case 'dealDetails.eventType':
                if (dropdownsData.eventType && Array.isArray(dropdownsData.eventType)) {
                  options = [...dropdownsData.eventType];
                }
                break;
              case 'dealDetails.contentRights':
                if (dropdownsData.contentRights && Array.isArray(dropdownsData.contentRights)) {
                  options = [...dropdownsData.contentRights];
                }
                break;
              case 'dealDetails.paymentTerms':
                if (dropdownsData.paymentTerms && Array.isArray(dropdownsData.paymentTerms)) {
                  options = [...dropdownsData.paymentTerms];
                }
                break;
              case 'dealDetails.clientOrientation':
                if (
                  dropdownsData.clientOrientation &&
                  Array.isArray(dropdownsData.clientOrientation)
                ) {
                  options = [...dropdownsData.clientOrientation];
                }
                break;
              case 'dealDetails.revenueTier':
                if (dropdownsData.revenueTier && Array.isArray(dropdownsData.revenueTier)) {
                  options = [...dropdownsData.revenueTier];
                }
                break;
              case 'dealDetails.clientFitScore':
                if (dropdownsData.clientFitScore && Array.isArray(dropdownsData.clientFitScore)) {
                  options = [...dropdownsData.clientFitScore];
                }
                break;
              case 'dealDetails.careerStage':
                if (dropdownsData.careerStage && Array.isArray(dropdownsData.careerStage)) {
                  options = [...dropdownsData.careerStage];
                }
                break;
              default:
                options = field.options ? [...field.options] : [];
            }

            return {
              ...field,
              options: options.length > 0 ? options : field.options ? [...field.options] : [],
            };
          }
          return field;
        });

        setFields(updatedFields);
      } catch (error) {
        console.error('Failed to fetch dropdown values:', error);
        setFields(BASE_FIELDS);
      }
    };

    fetchDropdowns();
  }, []);

  return <BaseDealForm fields={fields} />;
};
